import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

interface AgencyRouteProps {
  children: React.ReactNode;
}

export function AgencyRoute({ children }: AgencyRouteProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!user.is_agency) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}

